import { useRouter } from "next/router";
import { useEffect } from "react";

export default function LegacyProviders() {
  const router = useRouter();

  useEffect(() => {
    const url = new URL(window.location.href);
    url.pathname = "/connections";
    window.location.href = url.toString();
  }, [router]);
  return null;
}
